var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "qrcode-box" }, [
    _vm.scanUrl
      ? _c("img", { attrs: { src: _vm.scanUrl, alt: "" } })
      : _vm._e(),
    _vm._v(" "),
    _vm.expired || _vm.scanned
      ? _c("div", { staticClass: "qrcode-info_mask" })
      : _vm._e(),
    _vm._v(" "),
    _vm.expired || _vm.scanned
      ? _c("div", { staticClass: "qrcode-info_wrap" }, [
          _c("div", { staticClass: "qrcode-info" }, [
            _vm.expired
              ? _c("div", { staticClass: "qrcode-info_label" }, [
                  _vm._v("当前二维码已过期")
                ])
              : _vm.scanned
              ? _c("div", { staticClass: "qrcode-info_label" }, [
                  _vm._v("\n        已扫描，请在手机上确认\n      ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "qrcode-info_btn",
                attrs: { href: "javascript:;" },
                on: { click: _vm.getCode }
              },
              [_vm._v("刷新")]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-153951b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-153951b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/qrcode/login.vue
// module id = null
// module chunks = 